import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AppMenuitem } from '@/layout/components/app.menuitem';
import { BootstrapStore } from '@/core/bootstrap.store';
import { BootstrapMenuItem } from '@/core/bootstrap.interface';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [AppMenuitem, RouterModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<ul class="layout-menu">
        @for (item of model(); track item.label; let i = $index) {
            @if (!item.separator) {
                <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
            }
            @if (item.separator) {
                <li class="menu-separator"></li>
            }
        }
    </ul>`
})
export class AppMenu {
    private readonly bootstrapStore = inject(BootstrapStore);

    private readonly fallback: BootstrapMenuItem[] = [];

    readonly model = computed(() => {
        const menu = this.bootstrapStore.menu();
        return menu.length > 0 ? menu : this.fallback;
    });
}
